var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "tile is-ancestor is-parent" }, [
    _c("div", { staticClass: "tile is-parent" }, [
      _c(
        "article",
        { staticClass: "tile is-child" },
        [
          _vm.displaySubQuoteImage
            ? _c("div", [
                _c("h6", { staticClass: "title is-6" }, [
                  _vm._v("Add Image(s) From Additional"),
                ]),
                _c(
                  "div",
                  { staticClass: "field" },
                  _vm._l(_vm.subQuoteNos, function (quote) {
                    return _c("span", { key: quote.key }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "pretty p-icon p-curve p-smooth p-bigger",
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedQuotes,
                                expression: "selectedQuotes",
                              },
                            ],
                            attrs: {
                              id: `quote${quote.key}`,
                              type: "checkbox",
                              checked: "checked",
                            },
                            domProps: {
                              value: quote,
                              checked: Array.isArray(_vm.selectedQuotes)
                                ? _vm._i(_vm.selectedQuotes, quote) > -1
                                : _vm.selectedQuotes,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedQuotes,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = quote,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedQuotes = $$a.concat([$$v]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedQuotes = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedQuotes = $$c
                                }
                              },
                            },
                          }),
                          _c("div", { staticClass: "state p-primary" }, [
                            _c("i", { staticClass: "icon mdi mdi-check" }),
                            _c("label", [
                              _vm._v(
                                _vm._s(
                                  quote.key === 0 ? "Quote" : `Add ${quote.key}`
                                )
                              ),
                            ]),
                          ]),
                        ]
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._l(_vm.imageCategories, function (category) {
            return [
              _c("image-select-category", {
                key: category.quoteImageCategoryId,
                attrs: {
                  categories: _vm.imageCategories,
                  "quote-id": _vm.quoteId,
                  images: _vm.imagesWithInfo,
                  category: category.name,
                  "category-id": category.quoteImageCategoryId,
                  "category-order-index": category.orderIndex,
                  "quote-ids": _vm.quoteIds,
                  "max-selected": _vm.maxSelected,
                  "is-audanet": _vm.isAudanet,
                  "sub-title": _vm.subtitle,
                  "pre-select": _vm.preSelect,
                },
                on: { "update-images": _vm.updateImages },
              }),
            ]
          }),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }